import React, { memo } from 'react'
import map from 'ramda/src/map'

import withStyles from '@material-ui/core/styles/withStyles'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import ButtonNew from 'root/src/client/web/base/ButtonNew'
import Link from 'root/src/client/web/base/Link'
import style from './style'

const { heading2, heading4, paragraph } = typographyVariants
const StatItems = ({ classes, stats }) => map(({ number, text }) => (
	<div className={classes.statisticsItem} key={text}>
		<Typography
			className={classes.statContent}
			variant={heading2}
		>
			{number}
		</Typography>
		<Typography
			className={classes.statContent}
			variant={paragraph}
		>
			{text}
		</Typography>
	</div>
), stats)

const Statistics = ({ buttons, stats, classes }) => (
	<div className={classes.root}>
		<div className={classes.statisticsContainer}>
			<StatItems classes={classes} stats={stats} />
			<div className={classes.strongStatContent}>
				<Typography
					variant={heading4}
				>
					Game on.
				</Typography>
			</div>
		</div>
		<div className={classes.buttonsContainer}>
			{map(({ type, text, href, routeId }) => (
				<Link
					href={href}
					routeId={routeId}
					key={text}
				>
					<ButtonNew className={classes.button} type={type}>{text}</ButtonNew>
				</Link>
			), buttons)}
		</div>
	</div>
)

export default withStyles(style, { name: 'MuiStatistics' })(memo(Statistics))
